

/** @type {import('.')} */
module.exports = Object;




//////////////////
// WEBPACK FOOTER
// ../node_modules/es-object-atoms/index.js
// module id = ../node_modules/es-object-atoms/index.js
// module chunks = 1